import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import DashboardLayout from "./layouts/dashboard";
import LogoOnlyLayout from "./layouts/LogoOnlyLayout";
import {
  ForgetPassword,
  Programmes,
  ProgrammesDetail,
  Calender,
  ClientVideos,
  AdminVideos,
  AddAdminVideos,
  AdminVideoDetail,
  AddClientVideos,
  ClientVideoDetail,
  EditAdminVideos,
  EditClientVideos,
} from "./pages/index";
import Login from "./pages/Login";
import DashboardApp from "./pages/DashboardApp";
import AddProgramme from "./pages/Programmes/AddProgramme";
import EditProgramme from "./pages/Programmes/EditProgramme";
import MembersList from "./pages/Members/MembersList";
import AddMember from "./pages/Members/AddMember";
import EditMember from "./pages/Members/EditMember";
import ConsultantList from "./pages/consultant/consultantList";
import ChangePassword from "./pages/Members/ChangePassword";
import MemberProfile from "./pages/Members/MemberProfile";
import PaymentTransactionsList from "./pages/Payments/TransactionsList";
import StripeProductsList from "./pages/Payments/StripeProductsList";
import AddStripeProduct from "./pages/Payments/AddStripeProduct";
import EditStripeProduct from "./pages/Payments/EditStripeProduct";
import Calenders from "./pages/Calender/Calender";
import UpdateGeneralSetting from "./pages/ClientSetting/GeneralSetting";
import UpdateContentSetting from "./pages/ClientSetting/ContentSetting";
import AddStripeSetting from "./pages/SiteSetting/StripeSetting";
import EmailSetting from "./pages/SiteSetting/EmailSetting";
import DefaultSetting from "./pages/SiteSetting/DefaultSetting";
import EmailTemplates from "./pages/SiteSetting/EmailTemplates";
import EditEmailTemplate from "./pages/SiteSetting/EditEmailTemplate";
import { EmailTemplatePreview } from "./pages/SiteSetting/EmailTemplatePreview";
import UpdatePageContent from "./pages/WebPages/WebsitePages/UpdatePageContent";
import EditProfile from "./pages/EditProfile/EditProfile";
import WebsiteProgrammesList from "./pages/WebPages/WebsiteProgrammes/WebsiteProgrammesList";
import AddWebsiteProgramme from "./pages/WebPages/WebsiteProgrammes/AddOrUpdateProgramme";
import TemplatePages from "./pages/WebPages/TemplatePages/TemplatePages";
import SocialSharingSetting from "./pages/WebPages/TemplatePages/SoicalSharingSetting";
import PageSubscribersList from "./pages/WebPages/TemplatePages/PageSubscribersList";
import AddOrUpdatePage from "./pages/WebPages/WebsitePages/AddOrUpdatePage";
import UpdateThanksContent from "./pages/WebPages/WebsitePages/UpdateThanksContent";
import AddOrUpdateWebPageTestimonial from "./pages/WebPages/WebPageTestimonials/AddOrUpdateWebPageTestimonial";
import WebPageFaqs from "./pages/WebPages/WebPageFaqs/WebPageFaqs";
import AddOrUpdateWebPageFaq from "./pages/WebPages/WebPageFaqs/AddOrUpdateWebPageFaq";
import MenuList from "./pages/WebPages/WebsitePages/MenuItems/MenuList";
import { MenuItems } from "./pages/WebPages/WebsitePages/MenuItems/MenuItems";
import WebPageTestimonials from "./pages/WebPages/WebPageTestimonials/WebPageTestimonials";
import WebPagePaymentPlans from "./pages/WebPages/WebPagePaymentPlans/WebPagePaymentPlans";
import AddOrUpdatePaymentPlan from "./pages/WebPages/WebPagePaymentPlans/AddOrUpdatePaymentPlan";
import BusinessStrategyList from "./pages/WebPages/BusinessStrategy/BusinessStrategyList";
import AddOrUpdateBusinessStrategy from "./pages/WebPages/BusinessStrategy/AddOrUpdateBusinessStrategy";
import AddBusinessStrategy from "./pages/WebPages/BusinessStrategy/AddOrUpdateBusinessStrategy";
import SuccessScheduleList from "./pages/WebPages/SuccessSchedule/successScheduleList";
import AddOrUpdateSuccessSchedule from "./pages/WebPages/SuccessSchedule/AddOrUpdateSuccessSchedule";
import SiteSetting from "./pages/WebPages/WebPageFaqs/SiteSetting";
import UnpublishSetting from "./pages/WebPages/WebsitePages/UnpublishSetting";
import BannerSliderList from "./pages/WebPages/BannerSlider/BannerSliderList";
import AddBannerSlider from "./pages/WebPages/BannerSlider/AddBannerSlider";
import InvoiceSetting from "./components/InvoiceSetting/InvoiceSetting";
import SubscriptionList from "./pages/SubscriptionList/SubscriptionList";
import MemberSubscriptions from "./pages/Members/MemberSubscriptions/MemberSubscriptions";
import PagePlanSubscribersList from "./pages/WebPages/WebPagePaymentPlans/PagePlanSubscribersList";
import ProgrammeAccessPaymentPlan from "./pages/WebPages/WebPagePaymentPlans/ProgrammeAccessPaymentPlan";
import EventAccessPaymentPlan from "./pages/WebPages/WebPagePaymentPlans/EventAccessPaymentPlan";
import ExercisListing from "./pages/Exercises/ExercisListing";
import AddExercise from "./pages/Exercises/AddExercise";
import ExerciseDetail from "./pages/Exercises/ExerciseDetail";
import AddCoach from "./pages/consultant/AddCoach";
import EditCoach from "./pages/consultant/EditCoach";
import ChangeCoachPassword from "./pages/consultant/Changepassword";
import EditExercise from "./pages/Exercises/EditExercise";
import ExercisListingType from "./pages/ExercisesType/ExercisListingType";
import AddExerciseType from "./pages/ExercisesType/AddExerciseType";
import EditExerciseType from "./pages/ExercisesType/EditExerciseType";
import WorkoutDetail from "./pages/Workout/WorkoutDetail";
import FormTemplates from "./pages/UserFormTemplate/FormTemplates";
import AddFormTemplate from "./pages/UserFormTemplate/addFormTemplate";
import EditFormTemplate from "./pages/UserFormTemplate/editFormTemplate";
import TemplatePreview from "./pages/UserFormTemplate/templatePreview";
import UserForm from "./pages/UserForms/UserForm";
import AddForm from "./pages/UserForms/AddForm";
import EditForm from "./pages/UserForms/EditForm";
import DetailsFormInformation from "./pages/UserForms/DetailsFormInformation";
import ListUserForm from "./pages/Members/UserForms/ListUserForm";
import DynamicTable from "./pages/Calender/component/FixedCalender";
import AddWorkout from "./pages/Workout/AddWorkoutNew";
import EditWorkout from "./pages/Workout/EditWorkoutNew";
import MemberCalendar from "./pages/Members/MemberCalendar";
import WorkoutDisplay from "./pages/Banner/WorkoutDisplay";
import ExerciseTages from "./pages/ExercisesTages/ExerciseTages";
import ProgramUsersForm from "./pages/Programmes/UserForms";
import Feed from "./pages/CommunityFeeds/Feed";
import Groups from "./pages/Groups/Groups";
import AddGroups from "./pages/Groups/AddGroups";
import EditGroup from "./pages/Groups/EditGroup";
import GroupMembers from "./pages/Groups/GroupMembers";
import GroupsFeedsDetail from "./pages/CommunityFeeds/GroupsFeedsDetail";
import PendingPosts from "./pages/CommunityFeeds/PendingPosts";
import RejectedPosts from "./pages/CommunityFeeds/RejectedPosts";
import MyPosts from "./pages/CommunityFeeds/MyPosts";
import UserFormAgainstProgram from "./pages/UserForms/Components/UserFormAgainstProgram";
import PostDetail from "./pages/CommunityFeeds/PostDetail";
import FeedDetailPage from "./pages/CommunityFeeds/FeedDetailPage";
import AddfoodMatters from "./pages/FoodMattersLibrary/AddfoodMatters";
import EditFoodMatters from "./pages/FoodMattersLibrary/EditFoodMatters";
import AddMindset from "./pages/MindSetLibrary/AddMindset";
import EditMindset from "./pages/MindSetLibrary/EditMindset";
import RecentPointsTable from "./pages/Members/RecentPointsTable";
import AddProgrammeTemplate from "./pages/ProgrammesTemplates/AddProgrammeTemplate";
import EditProgrammeTemplate from "./pages/ProgrammesTemplates/EditProgrammeTemplate";
import ProgrammesTemplate from "./pages/ProgrammesTemplates/ProgrammesTemplate";
import AdminVideosCatagories from "./pages/HelpingVideos/AdminVideosCatagories";
import AddAdminCategory from "./pages/HelpingVideos/AddAdminCategory";
import EditAdminVideosCategory from "./pages/HelpingVideos/EditAdminVideosCategory";
import AddOrUpdateWebPagePlanCategory from "./pages/WebPages/WebPagePlanCategory/AddOrUpdateWebPagePlanCategory";
import WebPagePlanCategory from "./pages/WebPages/WebPagePlanCategory/WebPagePlanCategory";
import WebPageManagePlanCategory from "./pages/WebPages/WebPagePlanCategory/WebPageManagePlanCategory";
import AddVideoSet from "./pages/VideoLibrary/AddVideoSet";
import EditVideoSet from "./pages/VideoLibrary/EditVideoSet";
import AddCommentSet from "./pages/CommentLibrary/AddCommentSet";
import EditCommentSet from "./pages/CommentLibrary/EditCommentSet";
import Chat from "./pages/Chat/Chat";
import UserFormMembers from "./pages/UserForms/UserFormMembers";
import MainUserFormList from "./pages/UserForms/MainUserFormList";
import CalendarEvents from "./pages/MyCalender/CalendarEvents";
import CalendarSetting from "./pages/SiteSetting/CalendarSetting";
import ManageBookingSetting from "./pages/SiteSetting/ManageBookingSetting";
import ProgrammeBoookingSetting from "./pages/Programmes/ProgrammeBoookingSetting";
import SupportTicket from "./pages/SupportTickets/SupportTicket";
import SupportTicketDetail from "./pages/SupportTickets/SupportTicketDetail";
import AddOrEditFood from "./pages/Food/AddOrEditFood";
import FoodList from "./pages/Food/FoodList";
import WeightTracker from "./pages/Members/WeightTracker";
import ProgrammesFolder from "./pages/Programmes/ProgrammesFolder";
import AddOrUpdateFolder from "./pages/Programmes/AddOrUpdateFolder";
import AddWorkBook from "./pages/MindSetLibrary/AddWorkBook";
import EditWorkBook from "./pages/MindSetLibrary/EditWorkBook";
import TrackersList from "./pages/Trackers/TrackersList";
import AddOrEditTracker from "./pages/Trackers/AddOrEditTracker";
import CreateTrackerIntentPage from "./pages/Trackers/CreateTrackerIntentPage";
import TrackerDetailPage from "./pages/Trackers/TrackerDetailPage";
import TrackerQuestionsList from "./pages/Trackers/questions/TrackerQuestionsList";
import TrackerAutomationsList from "./pages/Trackers/automations/TrackerAutomationsList";
import AddOrEditAutomationPage from "./pages/Trackers/automations/AddOrEditAutomationPage";
import AddOrEditWorkflowPage from "./pages/Trackers/automations/AddOrEditWorkflowPage";
import AutomationBuilderPage from "./pages/Trackers/automationBuilder/AutomationBuilderPage";
import TrackerSubmissionsList from "./pages/Trackers/TrackerSubmissionsList";
import TrackerSubmissionDetailPage from "./pages/Trackers/TrackerSubmissionDetailPage";
import HarmonyProgram from "./pages/HarmonyProgram";
import MemberChartInfo from "./pages/Programmes/MemberChartInfo";
import GeneralListingType from "./pages/GeneralLibraryType/GeneralListingType";
import GeneralListing from "./pages/GeneralLibraryType/GeneralListing";
import ProgrammeBulkAccess from "./components/ProgrammBulkAccess/ProgrammeBulkAccess";

const Authentication = () => {
  if (localStorage.getItem("token")) {
    return <Navigate to="/dashboard"> </Navigate>;
  }
  if (!localStorage.getItem("token")) {
    return <Navigate to="/login"> </Navigate>;
  }
};
export default function Router() {
  return (
    <Routes>
      <Route element={<DashboardLayout />}>
        <Route path="/" element={<Authentication />} />
        <Route path="/dashboard" element={<DashboardApp />} />
        <Route
          path="/dashboard/harmony-program/:program_id"
          element={<HarmonyProgram />}
        />
        <Route
          path="/dashboard/harmony-program/:id/:CalId"
          element={<MemberChartInfo />}
        />{" "}
        <Route
          path="/member/:id/member-MemberCalendar/:CalId/graph"
          element={<MemberChartInfo />}
        />
        <Route
          path="/user_form-templates/add-user_form-templates"
          element={<AddFormTemplate />}
        />{" "}
        <Route
          path="/user_form-templates/edit-user_form-templates/:id"
          element={<EditFormTemplate />}
        />
        <Route
          path="/user_form-templates/preview-user_form-templates/:id"
          element={<TemplatePreview />}
        />
        <Route path="/user_form-templates" element={<FormTemplates />} />
        <Route path="/form-list" element={<MainUserFormList />} />
        <Route path="/form-list/forms-send-forms" element={<AddForm />} />
        <Route
          path="/form-list/forms-edit-forms/:slug"
          element={<EditForm />}
        />
        <Route path="/form-list/forms/:id" element={<UserForm />} />
        <Route
          path="/form-list/forms/forms-preview/:slug"
          element={<DetailsFormInformation page_type="forms" />}
        />
        <Route
          path="/form-list/forms/members/:id"
          element={<UserFormMembers />}
        />
        <Route
          path="/form-list/forms/members/forms-preview/:slug/:user_id"
          element={<DetailsFormInformation page_type="members_forms" />}
        />
        <Route
          path="/coach/List-forms/:id"
          element={<ListUserForm type="coach" />}
        />
        <Route
          path="/member/List-forms/:id"
          element={<ListUserForm type="member" />}
        />
        <Route
          path="/member/forms-preview/:slug/:user_id"
          element={<DetailsFormInformation page_type="members_forms" />}
        />
        <Route
          path="/coach/forms-preview/:slug/:user_id"
          element={<DetailsFormInformation page_type="members_forms" />}
        />
        <Route
          path="/programmes/programmes-form/:id"
          element={<ProgramUsersForm />}
        />
        <Route
          path="/programmes/members/:id"
          element={<UserFormMembers type="programmes" />}
        />
        <Route
          path="/programmes/programmes-form/forms-preview/:slug"
          element={<DetailsFormInformation page_type="forms" />}
        />
        <Route
          path="/forms/:fId/template/:tId/program/:id"
          element={<UserFormAgainstProgram />}
        />
        <Route path="/programmes/forms/:id" element={<UserFormMembers />} />
        <Route
          path="/programmes/forms/:fId/template/:tId/program/:id"
          element={<UserFormAgainstProgram />}
        />
        <Route
          path="/programmes/members/forms-preview/:slug/:user_id"
          element={<DetailsFormInformation page_type="members_forms" />}
        />
        <Route
          path="/programmes/forms-preview/:slug"
          element={<DetailsFormInformation />}
        />
        <Route path="/exercise" element={<ExercisListing />} />
        <Route path="/exercise-add" element={<AddExercise />} />
        <Route path="/exercise-edit/:slug" element={<EditExercise />} />
        <Route path="/exercise-details/:slug" element={<ExerciseDetail />} />
        <Route path="/type-exercise" element={<ExercisListingType />} />
        <Route path="/tages-exercise" element={<ExerciseTages />} />
        <Route path="/workout-add" element={<AddWorkout />} />
        <Route path="/workout-edit/:slug" element={<EditWorkout />} />
        <Route path="/workout-details/:slug" element={<WorkoutDetail />} />
        <Route path="/type-exercise-add" element={<AddExerciseType />} />
        <Route path="/food_matters-add" element={<AddfoodMatters />} />
        <Route path="/food_matters-edit/:slug" element={<EditFoodMatters />} />
        <Route
          path="/mindset_type"
          element={<GeneralListingType type="mindset" />}
        />
        <Route
          path="/nutrition_type"
          element={<GeneralListingType type="food" />}
        />
        <Route
          path="/video_type"
          element={<GeneralListingType type="video" />}
        />
        <Route
          path="/comment_type"
          element={<GeneralListingType type="comment" />}
        />
        <Route
          path="/workout_type"
          element={<GeneralListingType type="workout" />}
        />
        <Route
          path="/nutrition_library"
          element={<GeneralListing type="food" />}
        />
        <Route
          path="/workout_library"
          element={<GeneralListing type="workout" />}
        />{" "}
        <Route
          path="/mindset_library"
          element={<GeneralListing type="mindset" />}
        />
        <Route
          path="/video_library"
          element={<GeneralListing type="video" />}
        />{" "}
        <Route
          path="/comment_library"
          element={<GeneralListing type="comment" />}
        />
        <Route
          path="/workbook_library"
          element={<GeneralListing type="workbook" />}
        />
        <Route path="/trackers" element={<TrackersList />} />
        <Route path="/trackers/new" element={<CreateTrackerIntentPage />} />
        <Route path="/trackers/new/:intent" element={<AddOrEditTracker />} />
        <Route path="/trackers/edit/:id" element={<AddOrEditTracker />} />
        <Route path="/trackers/:id" element={<TrackerDetailPage />} />
        <Route
          path="/tracker-submissions"
          element={<TrackerSubmissionsList />}
        />
        <Route
          path="/tracker-submissions/:id"
          element={<TrackerSubmissionDetailPage />}
        />
        <Route path="/tracker-questions" element={<TrackerQuestionsList />} />
        <Route
          path="/tracker-automations"
          element={<TrackerAutomationsList />}
        />
        <Route
          path="/tracker-automations/new"
          element={<AddOrEditAutomationPage />}
        />
        <Route
          path="/tracker-automations/:automationId/workflows/:workflowId"
          element={<AddOrEditWorkflowPage />}
        />
        <Route
          path="/tracker-automations/:id"
          element={<AddOrEditAutomationPage />}
        />
        <Route
          path="/tracker-automation-builder/new"
          element={<AutomationBuilderPage />}
        />
        <Route
          path="/tracker-automation-builder/:id"
          element={<AutomationBuilderPage />}
        />
        <Route path="/food" element={<FoodList />} />
        <Route path="/food/add-food" element={<AddOrEditFood />} />
        <Route path="/food/edit-food/:food_id" element={<AddOrEditFood />} />
        <Route path="/mindset-add" element={<AddMindset />} />
        <Route path="/mindset-edit/:slug" element={<EditMindset />} />
        <Route path="/videoset-add" element={<AddVideoSet />} />
        <Route path="/videoset-edit/:slug" element={<EditVideoSet />} />
        <Route path="/commentset-add" element={<AddCommentSet />} />
        <Route path="/commentset-edit/:slug" element={<EditCommentSet />} />
        <Route path="/workbook-add" element={<AddWorkBook />} />
        <Route path="/workbook-edit/:slug" element={<EditWorkBook />} />
        <Route
          path="/type-exercise-edit/:slug"
          element={<EditExerciseType />}
        />
        <Route
          path="/programmes/:folder_id"
          element={<Programmes type="active" />}
        />
        <Route path="/programmes-folder" element={<ProgrammesFolder />} />
        <Route
          path="/programmes-folder/add-folder"
          element={<AddOrUpdateFolder />}
        />{" "}
        <Route
          path="/programmes-folder/edit-folder/:folder_id"
          element={<AddOrUpdateFolder />}
        />
        <Route
          path="/inactive-programmes"
          element={<Programmes type="inactive" />}
        />
        <Route
          path="/programmes/programmes-detail/:id"
          element={<ProgrammesDetail />}
        />
        <Route
          path="/programmes/booking-setting/:id"
          element={<ProgrammeBoookingSetting />}
        />
        <Route path="/programmes/:type/:id" element={<ProgrammeBulkAccess />} />
        <Route
          path="/programmes/add-programme/:folder_id"
          element={<AddProgramme />}
        />
        <Route
          path="/programmes/edit-programme/:programme_slug"
          element={<EditProgramme />}
        />
        <Route path="/programme_templats" element={<ProgrammesTemplate />} />
        <Route
          path="/programme_templats/add-programme_templats"
          element={<AddProgrammeTemplate />}
        />
        <Route
          path="/programme_templats/programme_templats-detail/:id"
          element={<ProgrammesDetail />}
        />
        <Route
          path="/programme_templats-limited-calendar/:id/:slug"
          element={<DynamicTable />}
        />
        <Route
          path="/programme_templats/edit-programme_templats/:programme_slug"
          element={<EditProgrammeTemplate />}
        />
        <Route
          path="/programme_templats-calendar/:id/:slug"
          element={<Calenders />}
        />
        <Route path="/member" element={<MembersList />} />
        <Route
          path="/member/List-forms/:id/form/:slug"
          element={<DetailsFormInformation page_type="members_forms" />}
        />
        <Route path="/member/add-member" element={<AddMember />} />
        <Route path="/member/edit-member/:id" element={<EditMember />} />
        <Route path="/member/weight-tracker/:id" element={<WeightTracker />} />
        <Route path="/member/member-profile/:id" element={<MemberProfile />} />
        <Route
          path="/member/member-points/:id"
          element={<RecentPointsTable />}
        />
        <Route
          path="/member/:id/member-MemberCalendar/:CalId"
          element={<MemberCalendar />}
        />
        <Route
          path="/member/member-subscribers/:member_id"
          element={<MemberSubscriptions />}
        />
        <Route
          path="/member/change-password/:id"
          element={<ChangePassword />}
        />
        <Route
          path="/programmes-limited-calendar/:id/:slug"
          element={<DynamicTable />}
        />
        <Route path="/chat" element={<Chat />} />
        <Route
          path="/coach/List-forms/:id/form/:slug"
          element={<DetailsFormInformation />}
        />
        <Route path="/coach" element={<ConsultantList />} />
        <Route path="/coach/add-coach" element={<AddCoach />} />
        <Route path="/coach/edit-coach/:id" element={<EditCoach />} />
        <Route
          path="/coach/change-password/:id"
          element={<ChangeCoachPassword />}
        />
        <Route path="/calendar-events" element={<CalendarEvents />} />
        <Route
          path="/website-pages/:page_id/business-strategy"
          element={<BusinessStrategyList />}
        />
        <Route
          path="/website-pages/:page_id/business-strategy/add-business-strategy"
          element={<AddOrUpdateBusinessStrategy />}
        />
        <Route
          path="/website-pages/:page_id/business-strategy/edit-business-strategy/:strategy_id"
          element={<AddOrUpdateBusinessStrategy />}
        />
        <Route path="/website-pages" element={<TemplatePages />} />
        <Route
          path="/website-pages/:page_id/testimonials/add-testimonial"
          element={<AddOrUpdateWebPageTestimonial />}
        />
        <Route
          path="/website-pages/:page_id/website-faq"
          element={<WebPageFaqs />}
        />
        <Route
          path="/website-pages/:page_id/website-faq/add-faq"
          element={<AddOrUpdateWebPageFaq />}
        />
        <Route
          path="/template-pages/edit-page/:page_slug"
          element={<AddOrUpdatePage />}
        />
        <Route
          path="/template-pages/:page_id/testimonials/add-testimonial"
          element={<AddOrUpdateWebPageTestimonial />}
        />
        <Route
          path="/template-pages/:page_id/payment-plans"
          element={<WebPagePaymentPlans />}
        />
        <Route
          path="/template-pages/:page_id/payment-plans/add-plan"
          element={<AddOrUpdatePaymentPlan />}
        />
        <Route
          path="/template-pages/:page_id/payment-plans/edit-plan/:plan_id"
          element={<AddOrUpdatePaymentPlan />}
        />
        <Route
          path="/template-pages/:page_id/business-strategy"
          element={<BusinessStrategyList />}
        />
        <Route
          path="/template-pages/:page_id/business-strategy/add-business-strategy"
          element={<AddBusinessStrategy />}
        />
        <Route
          path="/template-pages/:page_id/business-strategy/edit-business-strategy/:strategy_id"
          element={<AddBusinessStrategy />}
        />
        <Route
          path="/website-pages/:page_id/success-schedule"
          element={<SuccessScheduleList />}
        />
        <Route
          path="/template-pages/:page_id/success-schedule"
          element={<SuccessScheduleList />}
        />
        <Route
          path="/template-pages/:page_id/add-success-schedule"
          element={<AddOrUpdateSuccessSchedule />}
        />
        <Route
          path="/website-pages/:page_id/add-success-schedule"
          element={<AddOrUpdateSuccessSchedule />}
        />
        <Route
          path="/website-pages/:page_id/edit-success-schedule/:success_id"
          element={<AddOrUpdateSuccessSchedule />}
        />
        <Route
          path="/template-pages/:page_id/payment-plans"
          element={<WebPagePaymentPlans />}
        />
        <Route
          path="/template-pages/social-sharing-setting/:page_id"
          element={<SocialSharingSetting />}
        />
        <Route
          path="/template-pages/update-thanks-content/:id"
          element={<UpdateThanksContent />}
        />
        <Route
          path="/template-pages/update-page-content/:id"
          element={<UpdatePageContent />}
        />
        <Route
          path="/website-pages/social-sharing-setting/:page_id"
          element={<SocialSharingSetting />}
        />
        <Route
          path="/website-pages/page-subscriber/:id"
          element={<PageSubscribersList />}
        />
        <Route
          path="/template-pages/page-subscriber/:id"
          element={<PageSubscribersList />}
        />
        <Route path="/website-pages/add-page" element={<AddOrUpdatePage />} />
        <Route
          path="/website-pages/edit-page/:page_slug"
          element={<AddOrUpdatePage />}
        />
        <Route
          path="/website-pages/update-page-content/:id"
          element={<UpdatePageContent />}
        />
        <Route
          path="/website-pages/update-thanks-content/:id"
          element={<UpdateThanksContent />}
        />
        <Route
          path="/website-pages/:page_id/testimonials"
          element={<WebPageTestimonials />}
        />
        <Route
          path="/website-pages/:page_id/payment-plans/"
          element={<WebPagePaymentPlans />}
        />
        <Route
          path="/website-pages/:page_id/payment-plans/add-plan"
          element={<AddOrUpdatePaymentPlan />}
        />
        <Route
          path="/website-pages/:page_id/subscriber/:plan_id"
          element={<PagePlanSubscribersList />}
        />
        <Route
          path="/website-pages/:page_id/payment-plans/edit-plan/:plan_id"
          element={<AddOrUpdatePaymentPlan />}
        />
        <Route
          path="/website-pages/:page_id/plan_category/add-plan_category"
          element={<AddOrUpdateWebPagePlanCategory />}
        />
        <Route
          path="/website-pages/:page_id/plan_category/edit-plan_category/:category_id"
          element={<AddOrUpdateWebPagePlanCategory />}
        />
        <Route
          path="/template-pages/:page_id/plan_category/add-plan_category"
          element={<AddOrUpdateWebPagePlanCategory />}
        />
        <Route
          path="/plan_category/add-plan_category"
          element={<AddOrUpdateWebPagePlanCategory />}
        />
        <Route path="/plan_category" element={<WebPagePlanCategory />} />
        <Route
          path="/plan_category/edit-plan_category/:category_id"
          element={<AddOrUpdateWebPagePlanCategory />}
        />
        <Route
          path="/plan_category/manage-plan_category/:category_id"
          element={<WebPageManagePlanCategory />}
        />
        <Route
          path="/template-pages/:page_id/plan_category/edit-plan_category/:category_id"
          element={<AddOrUpdateWebPagePlanCategory />}
        />
        <Route
          path="/template-pages/:page_id/plans_category"
          element={<WebPagePlanCategory />}
        />
        <Route
          path="/website-pages/:page_id/plans_category"
          element={<WebPagePlanCategory />}
        />
        <Route
          path="/website-pages/unpublish-setting/:id"
          element={<UnpublishSetting />}
        />
        <Route
          path="/template-pages/unpublish-setting/:id"
          element={<UnpublishSetting />}
        />
        <Route path="/template-pages" element={<TemplatePages />} />
        <Route path="/menus" element={<MenuList />} />
        <Route path="/menu/add-menu" element={<MenuItems />} />
        <Route path="/menu/:id" element={<MenuItems />} />
        <Route
          path="/template-pages/:page_id/testimonials/add-testimonial"
          element={<AddOrUpdateWebPageTestimonial />}
        />
        <Route
          path="/template-pages/:page_id/testimonials/edit-testimonial/:testimonial_id"
          element={<AddOrUpdateWebPageTestimonial />}
        />
        <Route
          path="/template-pages/:page_id/testimonials"
          element={<WebPageTestimonials />}
        />
        <Route
          path="/template-pages/:page_id/payment-plans"
          element={<WebPagePaymentPlans />}
        />
        <Route
          path="/template-pages/:page_id/payment-plans/add-plan"
          element={<AddOrUpdatePaymentPlan />}
        />
        <Route
          path="/template-pages/:page_id/payment-plans/edit-plan/:plan_id"
          element={<AddOrUpdatePaymentPlan />}
        />
        <Route
          path="/template-pages/:page_id/website-programmes"
          element={<WebsiteProgrammesList />}
        />
        <Route
          path="/template-pages/:page_id/website-programmes/add-programme"
          element={<AddWebsiteProgramme />}
        />
        <Route
          path="/template-pages/:page_id/website-programmes/edit-programme/:programme_slug"
          element={<AddWebsiteProgramme />}
        />
        <Route path="/site-setting" element={<SiteSetting />} />
        <Route
          path="/website-pages/:page_id/testimonials/edit-testimonial/:testimonial_id"
          element={<AddOrUpdateWebPageTestimonial />}
        />
        <Route
          path="/website-pages/:page_id/website-faq"
          element={<WebPageFaqs />}
        />
        <Route path="/subscription-list" element={<SubscriptionList />} />
        <Route
          path="/website-pages/:page_id/subscriber/:plan_id"
          element={<PagePlanSubscribersList />}
        />
        <Route
          path="/template-pages/:page_id/payment-plans/:plan_id/manage-program-access"
          element={<ProgrammeAccessPaymentPlan />}
        />
        <Route
          path="/website-pages/:page_id/payment-plans/:plan_id/manage-program-access"
          element={<ProgrammeAccessPaymentPlan />}
        />
        <Route
          path="/website-pages/:page_id/payment-plans/:plan_id/manage-events-access"
          element={<EventAccessPaymentPlan />}
        />
        <Route
          path="/template-pages/:page_id/payment-plans/:plan_id/manage-events-access"
          element={<EventAccessPaymentPlan />}
        />
        <Route
          path="/template-pages/:page_id/subscriber/:plan_id"
          element={<PagePlanSubscribersList />}
        />
        <Route
          path="/website-pages/:page_id/website-programmes"
          element={<WebsiteProgrammesList />}
        />
        <Route
          path="/website-pages/:page_id/website-programmes/add-programme"
          element={<AddWebsiteProgramme />}
        />
        <Route
          path="/website-pages/:page_id/website-programmes/edit-programme/:programme_slug"
          element={<AddWebsiteProgramme />}
        />
        <Route
          path="/template-pages/:page_id/banner-slider"
          element={<BannerSliderList />}
        />
        <Route
          path="/template-pages/:page_id/add-banner-slider"
          element={<AddBannerSlider />}
        />
        <Route
          path="/website-pages/:page_id/banner-slider"
          element={<BannerSliderList />}
        />
        <Route
          path="/website-pages/:page_id/add-banner-slider"
          element={<AddBannerSlider />}
        />
        <Route
          path="/website-pages/:page_id/edit-banner-slider/:banner_id"
          element={<AddBannerSlider />}
        />
        <Route
          path="/template-pages/:page_id/edit-banner-slider/:banner_id"
          element={<AddBannerSlider />}
        />
        <Route path="/community-area" element={<Feed />} />
        <Route path="/pending-posts" element={<PendingPosts />} />
        <Route path="/pending-posts/post-detail" element={<PostDetail />} />
        <Route path="/rejected-posts/post-detail" element={<PostDetail />} />
        <Route path="/post-detail" element={<PostDetail />} />
        <Route
          path="/community-area-post-detail/:id"
          element={<FeedDetailPage />}
        />
        <Route path="/rejected-posts" element={<RejectedPosts />} />
        <Route path="/groups" element={<Groups />} />
        <Route path="/groups/add-group" element={<AddGroups />} />
        <Route path="/groups/edit-group/:slug" element={<EditGroup />} />
        <Route path="/groups/group-members/:slug" element={<GroupMembers />} />
        <Route
          path="/community-area/groups/group-members/:slug"
          element={<GroupMembers />}
        />
        <Route path="/group-feed/:id" element={<GroupsFeedsDetail />} />
        <Route path="/my-posts" element={<MyPosts />} />
        <Route
          path="/payment-transactions"
          element={<PaymentTransactionsList />}
        />
        <Route path="/stripe-products" element={<StripeProductsList />} />
        <Route
          path="/stripe-products/add-product"
          element={<AddStripeProduct />}
        />
        <Route
          path="/stripe-products/edit-product/:id"
          element={<EditStripeProduct />}
        />
        <Route path="/programmes-calendar/:id/:slug" element={<Calenders />} />
        <Route path="/general-setting" element={<UpdateGeneralSetting />} />
        <Route path="/invoice-setting" element={<InvoiceSetting />} />
        <Route path="/content-setting" element={<UpdateContentSetting />} />
        <Route path="/stripe-setting" element={<AddStripeSetting />} />
        <Route path="/email-setting" element={<EmailSetting />} />
        <Route path="/default-setting" element={<DefaultSetting />} />
        <Route path="/calendar-setting" element={<CalendarSetting />} />
        <Route
          path="/manage-booking-setting"
          element={<ManageBookingSetting />}
        />
        <Route path="/email-templates" element={<EmailTemplates />} />
        <Route
          path="/email-templates/preview/:id"
          element={<EmailTemplatePreview />}
        />
        <Route
          path="/email-templates/edit-email-template/:id"
          element={<EditEmailTemplate />}
        />
        <Route path="/profile" element={<EditProfile />} />
        <Route path="/calender" element={<Calender />} />
        <Route path="/support-ticket" element={<SupportTicket />} />
        <Route path="/support-ticket/:id" element={<SupportTicketDetail />} />
        <Route path="/coaches-videos" element={<AdminVideos />} />
        <Route
          path="/coaches_videos_category/coaches-videos/:id"
          element={<AdminVideos />}
        />
        <Route
          path="/coaches_videos_category"
          element={<AdminVideosCatagories />}
        />
        <Route
          path="/members_videos_category"
          element={<AdminVideosCatagories />}
        />
        <Route
          path="/coaches_videos_category/add"
          element={<AddAdminCategory />}
        />
        <Route
          path="/members_videos_category/add"
          element={<AddAdminCategory />}
        />
        <Route
          path="/coaches_videos_category/edit/:id"
          element={<EditAdminVideosCategory />}
        />
        <Route
          path="/members_videos_category/edit/:id"
          element={<EditAdminVideosCategory />}
        />
        <Route
          path="/coaches-videos/add-coach-videos/:id"
          element={<AddAdminVideos />}
        />
        <Route
          path="/coaches-videos/edit-coach-videos"
          element={<EditAdminVideos />}
        />
        <Route
          path="/members-videos/edit-member-videos"
          element={<EditClientVideos />}
        />
        <Route
          path="/coaches-videos/coach-videos-detail/:id"
          element={<AdminVideoDetail />}
        />
        <Route path="/members-videos" element={<ClientVideos />} />
        <Route
          path="/members_videos_category/members-videos/:id"
          element={<ClientVideos />}
        />
        <Route
          path="/members-videos/add-member-videos/:id"
          element={<AddClientVideos />}
        />
        <Route
          path="/members-videos/members-videos-detail/:id"
          element={<ClientVideoDetail />}
        />
        <Route path="*" element={<Authentication />} />
      </Route>

      <Route element={<LogoOnlyLayout />}>
        <Route path="/" element={<Authentication />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forget_password" element={<ForgetPassword />} />
        <Route path="/WorkoutDisplay" element={<WorkoutDisplay />} />
        <Route path="*" element={<Authentication />} />
      </Route>
    </Routes>
  );
}
